// Kontrol listesi + alt iş yardımcıları (saf). Contract 1.1:
// BayinerIOT-Workspace-/docs/api-contracts/tasks.md → "Kontrol listesi (1.1)", "Alt işler (1.1)"

const CLOSED = ["done", "cancelled"];

export const countChecklist = (items = []) => ({
  total: items.length,
  done: items.filter((i) => i.done).length,
});

// Yanıt ({ checklist, checklistCount }) iş taslağına (getTask cache'indeki TaskDetail) yazılır.
// checklistCount gelmezse listeden hesaplanır. version'a dokunulmaz (server artırmıyor).
export function applyChecklistResult(task, result) {
  if (!task || !result || !Array.isArray(result.checklist)) return task;
  task.checklist = result.checklist;
  task.checklistCount = result.checklistCount || countChecklist(result.checklist);
  return task;
}

// İyimser işaretleme (toggle) — hata olursa cache patch'i geri alınır.
export function applyChecklistToggle(task, itemId, done) {
  const item = (task?.checklist || []).find((i) => i._id === itemId);
  if (!item) return task;
  item.done = Boolean(done);
  task.checklistCount = countChecklist(task.checklist);
  return task;
}

// İyimser sıralama — itemIds tam liste; bilinmeyen id'ler atlanır, eksikler sona.
export function applyChecklistReorder(task, itemIds = []) {
  const list = task?.checklist;
  if (!Array.isArray(list)) return task;
  const byId = new Map(list.map((i) => [i._id, i]));
  const ordered = itemIds.map((id) => byId.get(id)).filter(Boolean);
  const rest = list.filter((i) => !itemIds.includes(i._id));
  task.checklist = [...ordered, ...rest];
  return task;
}

// Detayda subtasks varsa ondan, yoksa subtaskCount'tan: kapanmamış (bitti/iptal değil) alt iş var mı?
export function hasOpenSubtasks(task) {
  if (!task) return false;
  if (Array.isArray(task.subtasks) && task.subtasks.length) {
    return task.subtasks.some((s) => !CLOSED.includes(s.status));
  }
  const c = task.subtaskCount;
  return Boolean(c && c.total > c.done);
}
